import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import ServicePage from './pages/ServicePage';
import Referencer from './pages/Referencer';
import Contact from './pages/Contact';
import ThankYou from './pages/ThankYou';
import SkaermenHjernenOgTrivselen from './pages/SkaermenHjernenOgTrivselen';
import Trivlogi11 from './pages/Trivlogi11';
import TrivselIFaellesskabet from './pages/TrivselIFaellesskabet';
import { Navigate } from 'react-router-dom';

function App() {
  return (
    <div className="min-h-screen flex flex-col font-sans text-slate-900 antialiased selection:bg-emerald-100 selection:text-emerald-900">
      <ScrollToTop />
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/om" element={<About />} />
          <Route 
            path="/trivlogi-1-1" 
            element={<Trivlogi11 />} 
          />
          <Route 
            path="/trivsel-i-faellesskabet" 
            element={<TrivselIFaellesskabet />} 
          />
          <Route 
            path="/konflikten" 
            element={<Navigate to="/trivsel-i-faellesskabet#konflikter" replace />} 
          />
          <Route 
            path="/ledelsesudvikling" 
            element={<Navigate to="/trivsel-i-faellesskabet#ledelse" replace />} 
          />
          <Route path="/referencer" element={<Referencer />} />
          <Route path="/skaermen-hjernen-og-trivselen" element={<SkaermenHjernenOgTrivselen />} />
          <Route path="/skaermen-hjernen-og-trivslen" element={<SkaermenHjernenOgTrivselen />} />
          <Route path="/til-skoler" element={<SkaermenHjernenOgTrivselen />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/tak" element={<ThankYou />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
